import { generateOperationId } from "./operation.js";
/**
 * @see {@link RemoveEntityOperation}
 */
export const RemoveEntityOperationType = "https://schemas.dataspecer.com/core/operations/delete-entity";
export function createRemoveEntityOperation(entityId) {
    return {
        id: generateOperationId(),
        type: RemoveEntityOperationType,
        entityId,
    };
}
export function isRemoveEntityOperation(operation) {
    return operation.type === RemoveEntityOperationType;
}
/**
 * @see {@link SetEntityOperation}
 */
export const SetEntityOperationType = "https://schemas.dataspecer.com/core/operations/set-entity";
export function createSetEntityOperation(entity) {
    return {
        id: generateOperationId(),
        type: SetEntityOperationType,
        entity,
    };
}
export function isSetEntityOperation(operation) {
    return operation.type === SetEntityOperationType;
}
/**
 * @see {@link UpdateEntityOperation}
 */
export const UpdateEntityOperationType = "https://schemas.dataspecer.com/core/operations/update-entity";
export function createUpdateEntityOperation(entityId, update) {
    if (!(typeof entityId === "string" && entityId.length > 0)) {
        throw new Error("Invalid entity identifier.");
    }
    if (!(typeof update === "object" &&
        update !== null &&
        !("id" in update) &&
        !("type" in update))) {
        throw new Error("Invalid entity update.");
    }
    return {
        id: generateOperationId(),
        type: UpdateEntityOperationType,
        entityId,
        update,
    };
}
export function isUpdateEntityOperation(operation) {
    return operation.type === UpdateEntityOperationType;
}
//# sourceMappingURL=entity-operations.js.map